// Custom hook for tracking SPA page views
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
import { trackPostHogPageView } from '../lib/services/analytics/posthogService';

/**
 * Hook to automatically track page views in React Router SPA
 * Call this in your main App component or route wrapper
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from document or create meaningful title
    const getPageTitle = (pathname: string): string => {
      const titles: Record<string, string> = {
        '/': 'Home - Life Re:Scripted™',
        '/journal': 'Journal Hub - Life Re:Scripted™',
        '/community': 'Community - Life Re:Scripted™',
        '/wellness': 'Wellness Tools - Life Re:Scripted™',
        '/toolkit': 'Healing Toolkit - Life Re:Scripted™',
        '/lofi': 'LoFi Zone - Life Re:Scripted™',
        '/resources': 'Resources - Life Re:Scripted™',
        '/about': 'About - Life Re:Scripted™',
        '/founders-corner': 'Founders Corner - Life Re:Scripted™',
        '/contact': 'Contact - Life Re:Scripted™',
        '/profile': 'Profile - Life Re:Scripted™',
        '/admin': 'Admin Panel - Life Re:Scripted™',
      };

      return titles[pathname] || `${pathname.slice(1)} - Life Re:Scripted™`;
    };

    const pageTitle = getPageTitle(location.pathname);
    const pageLocation = `${window.location.origin}${location.pathname}${location.search}`;

    // Track the page view (GA4 + PostHog)
    trackPageView(pageTitle, pageLocation);
    trackPostHogPageView(pageTitle, pageLocation);

    // Update document title for better UX
    document.title = pageTitle;
  }, [location]);

  return null;
};
